import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/matrix/banner.png';
import _imports_1 from '@/assets/img/matrix/banner_h5.png';
const _withScopeId = n => (_pushScopeId("data-v-71481d15"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "matrix"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner_box"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "hidden-xs-only banner",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("img", {
  class: "hidden-sm-and-up banner",
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_3 = {
  class: "piece"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title hidden-xs-only"
}, " 跨平台短视频矩阵营销 为企业建立数字化内容营销中台 ", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title hidden-sm-and-up"
}, [/*#__PURE__*/_createElementVNode("div", null, "跨平台短视频矩阵营销"), /*#__PURE__*/_createElementVNode("div", null, "为企业建立数字化内容营销中台")], -1));
const _hoisted_6 = {
  class: "cards"
};
const _hoisted_7 = {
  class: "card"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "title"
};
const _hoisted_10 = {
  class: "info"
};
const _hoisted_11 = {
  class: "box"
};
const _hoisted_12 = {
  class: "left"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = {
  class: "right"
};
const _hoisted_15 = ["src"];
import { reactive } from "vue";
const __default__ = {
  metaInfo: {
    title: "短视频矩阵营销-京奇数据智慧营销",
    meta: [{
      name: "description",
      content: "京奇数据,跨平台短视频矩阵营销 为企业建立数字化内容营销平台."
    }, {
      name: "keywords",
      content: "短视频营销,内容营销,数字化营销,矩阵营销"
    }],
    link: [{
      rel: "",
      href: ""
    }]
  }
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Matrix',
  setup(__props) {
    const cards = reactive([{
      img: require("@/assets/img/matrix/card1.png"),
      titile: "AI视频中心",
      info: "赋能PUGC内容",
      text: "生产千倍提速"
    }, {
      img: require("@/assets/img/matrix/card2.png"),
      titile: "全员矩阵账号",
      info: "品牌+KOC",
      text: "+员工账号矩阵品牌"
    }, {
      img: require("@/assets/img/matrix/card3.png"),
      titile: "智能任务系统",
      info: "跨平台营销任务分发",
      text: "品效触达千倍提升"
    }, {
      img: require("@/assets/img/matrix/card4.png"),
      titile: "多效营销组件",
      info: "平台曝光成本",
      text: "降低10倍"
    }]);
    const list = reactive([{
      img: require("@/assets/img/matrix/img1.png"),
      title: "AI视频中心",
      texts: ["AI技术 赋能短视频内容生产千倍提速。", "多短视频平台营销任务一键分发，", "员工任务全流程管理+效果追踪，有效激励传播。", "多维度任务看板，精准管理全员营销绩效"]
    }, {
      img: require("@/assets/img/matrix/img2.png"),
      title: "全员账号矩阵",
      texts: ["企业员工，员工亲友、全民经纪人", "合作供应商及媒体等贡献传播点(账号)", "传播数据企业后台回收跟踪。全员短视频营销", "高密度种草放大品牌曝光量"]
    }, {
      img: require("@/assets/img/matrix/img3.png"),
      title: "智能任务系统",
      texts: ["视频任务一键领取、抖音、快手、视频号", "等多平台一键分发。多功能任务看板，", "实现精准全员营销管理。员工任务", "全流程管理+效果追踪，有效激励传播"]
    }, {
      img: require("@/assets/img/matrix/img4.png"),
      title: "多效营销组件",
      texts: ["全民激励任务、POI、团购等", "多效营销组件，构建多样化的内容", "经营模型，轻松获取并转化线索", "助力销售订单，形成企业数字化经营沉淀"]
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cards, (item, i) => {
        return _openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("img", {
          class: "img",
          src: item.img,
          alt: ""
        }, null, 8, _hoisted_8), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.titile), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, _toDisplayString(item.info), 1), _createElementVNode("div", null, _toDisplayString(item.text), 1)])])]);
      }), 256))])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: "piece"
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.texts, (text, ind) => {
          return _openBlock(), _createElementBlock("div", {
            class: "text",
            key: ind
          }, _toDisplayString(text), 1);
        }), 128))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
          class: "img",
          src: item.img,
          alt: ""
        }, null, 8, _hoisted_15)])])]);
      }), 128))]);
    };
  }
});